import {
  onCreateDailyMessage,
  onDeleteDailyMessage,
  onGetDailyMessage,
  onUpdateDailyMessage,
} from "services/apis/dailyMessage";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doGetDailyMessage = createAsyncThunk(
  "dailyMessage/doGetDailyMessage",
  async () => {
    const result = await onGetDailyMessage();
    if (!result) {
      return;
    }
    return result;
  }
);

export const doCreateDailyMessage = createAsyncThunk(
  "dailyMessage/doCreateDailyMessage",
  async params => {
    const result = await onCreateDailyMessage(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doUpdateDailyMessage = createAsyncThunk(
  "dailyMessage/doUpdateDailyMessage",
  async params => {
    const result = await onUpdateDailyMessage(params);
    if (!result) {
      return;
    }
    return result;
  }
);

export const doDeleteDailyMessage = createAsyncThunk(
  "dailyMessage/doDeleteDailyMessage",
  async params => {
    const result = await onDeleteDailyMessage(params);
    if (!result) {
      return;
    }
    return result;
  }
);

const initialState = {
  isSaving: false,
  dailyMessage: {},
};

const slice = createSlice({
  name: "dailyMessage",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [doGetDailyMessage.fulfilled]: (state, action) => {
      state.dailyMessage = action?.payload?.data;
    },
    [doCreateDailyMessage.fulfilled]: state => {
      state.isSaving = true;
    },
    [doUpdateDailyMessage.fulfilled]: state => {
      state.isSaving = true;
    },
    [doDeleteDailyMessage.fulfilled]: state => {
      state.isSaving = true;
    },
  },
});

const { reducer } = slice;

export default reducer;

export const isSaving = createSelector(
  state => state.dailyMessage.isSaving,
  isSaving => isSaving
);

export const dailyMessage = createSelector(
  state => state.dailyMessage.dailyMessage,
  dailyMessage => dailyMessage
);
